import React from 'react';
import Marquee from 'react-fast-marquee';

const CATEGORIES = [
  'Restaurants',
  'Cafés',
  'Bakeries',
  'Liquor Stores',
  'Grocers',
  'Specialty Food',
  'Local Retailers',
  'Butchers',
  'Dessert Shops',
];

/**
 * SocialProofBand — full-bleed red marquee sitting directly under the hero.
 *
 * Reinforces the Canadian-owned positioning and the breadth of businesses
 * Hungry Canadian serves. Uses continuous motion for energy without imagery.
 */
export default function SocialProofBand() {
  return (
    <section
      data-testid="social-proof-band"
      className="w-full bg-primary text-primary-foreground border-y border-black/10 py-5 md:py-6 overflow-hidden"
    >
      <p className="text-center text-[0.7rem] md:text-xs font-semibold uppercase tracking-[0.25em] text-primary-foreground/80 mb-4 px-4">
        Proudly Canadian-owned · Keeping more of every sale with local business
      </p>
      <Marquee gradient={false} speed={45} autoFill pauseOnHover>
        {CATEGORIES.map((c) => (
          <span key={c} className="flex items-center" data-testid={`proof-item-${c.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
            <span className="mx-8 md:mx-12 text-2xl md:text-4xl font-heading font-black uppercase tracking-tight">
              {c}
            </span>
            <span
              aria-hidden
              className="inline-block w-2.5 h-2.5 md:w-3 md:h-3 rotate-45 bg-primary-foreground/70"
            />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
